import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

const state = {
  // 登录后的基本信息
  userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
}

const options = {
  state,
  mutations,
  actions
}

export default new Vuex.Store(options)



// WEBPACK FOOTER //
// ./src/store/index.js